export default "__VITE_ASSET__CTNIYjSo__"